"use client"

import { jsx as n } from "react/jsx-runtime";
import { useState as f, useEffect as i, forwardRef as m } from "react";
import { E as u, u as c, A as l } from "./Addreth-_1H8QZKW.js";
import { a as k, T as v } from "./Addreth-_1H8QZKW.js";
import "react-dom";
function E({
  address: o,
  children: e,
  fetchSettings: s
}) {
  const [t, a] = f(null);
  return i(() => {
    let r = !1;
    return import("wagmi").then(
      (d) => {
        r || a(d);
      },
      () => {
        r || a(null);
      }
    ), () => {
      r = !0;
    };
  }, []), t ? /* @__PURE__ */ n(
    u,
    {
      address: o,
      fetchSettings: s,
      ensHooks: t,
      children: e
    }
  ) : e;
}
const p = m(function(e, s) {
  const t = c(e);
  return /* @__PURE__ */ n(
    E,
    {
      address: e.address,
      fetchSettings: {
        avatar: t.icon === "ens",
        name: t.label === "ens"
      },
      children: /* @__PURE__ */ n(
        l,
        {
          ref: s,
          address: e.address,
          config: t
        }
      )
    }
  );
});
export {
  p as Addreth,
  k as AddrethConfig,
  v as THEMES
};
//# sourceMappingURL=index.js.map
